// @flow

import React, { type Node } from 'react';
import { DisplayBrand } from '../commons';
import { useIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';
import { type Country } from '@tectonics/prs/country';
import safetypayOnlineIconSrc from './ico-safetypay-online.svg';
import safetypayBbvaIconSrc from './ico-bbva.svg';
import safetypayBcpIconSrc from './ico-bcp.svg';
import safetypayInterbankIconSrc from './ico-interbank.svg';
import safetypayScotiabankIconSrc from './ico-scotiabank.svg';
import safetypayYMas4IconSrc from './ico-y-mas-4.svg';
import styled from 'styled-components';

export function DisplaySafetypayOnlineBrand(): Node {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);

  return (
    <Root>
      <SafetypayBankIconsByCountry country={country} />
    </Root>
  );
}

type Props = {
  country: Country;
};

function SafetypayBankIconsByCountry({ country }: Props): Node {
  const brandsToDisplay = getPeruvianCardBrandsSrc();
  switch (country) {
    case 'pe':
      return (
        <>
          {brandsToDisplay.map(brand => (
            <SafetypayBanksBrandImageWrapper key={brand}>
              <SafetypayBanksBrandImage src={getCardBrandImageSrc(brand)} alt={brand} />
            </SafetypayBanksBrandImageWrapper>
          ))}
        </>
      );

    case 'ec':
      return (
        <DisplayBrand iconSrc={safetypayOnlineIconSrc} iconAlt="safetypay online" />
      );

    default:
      return null;
  }
}

function getPeruvianCardBrandsSrc(): string[] {
  return  ['bcp', 'bbva', 'interbank', 'scotiabank', 'y-mas-4'];
}

function getCardBrandImageSrc(brand: string): string {
  switch (brand) {
    case 'bbva':
      return safetypayBbvaIconSrc;

    case 'bcp':
      return safetypayBcpIconSrc;

    case 'interbank':
      return safetypayInterbankIconSrc;

    case 'scotiabank':
      return safetypayScotiabankIconSrc;

    case 'y-mas-4':
      return safetypayYMas4IconSrc;

    default:
      throw new Error(`Display Safetypay bank brand: there is no source for ${brand}`);
  }
}

const Root = styled.div`
  height: 100%;
  display: flex;
`;

const SafetypayBanksBrandImageWrapper = styled.div`
  flex-grow: 1;
  padding-left: 4px;
`;

const SafetypayBanksBrandImage = styled.img`
  height: 100%;
  width: 100%;
`;
